module.exports = __webpack_public_path__ + "img/stock2.9e702baf.png";